@if (baPerson) {
    <div
        class="global-search-person-snapshot--container"
        piTesting="global-search-person-snapshot"
    >
        <div class="global-search-person-snapshot--header">
            @if (showReferenceProfileIcon) {
                <div
                    class="global-search-person-snapshot--reference-profile-container"
                >
                    <tapestry-icon
                        [size]="IconSize.Large"
                        [name]="referenceProfileIcon"
                    ></tapestry-icon>
                    <div
                        class="global-search-person-snapshot--reference-profile-name"
                    >
                        {{ referenceProfileName | translate | titlecase }}
                    </div>
                </div>
            }
            <div class="global-search-person-snapshot--header-info-container">
                <div
                    class="global-search-person-snapshot--name tapestry-body bold"
                >
                    {{ fullName }}
                </div>
                <div class="global-search-person-snapshot--email">
                    {{ email }}
                </div>
            </div>
        </div>
        <div class="global-search-person-snapshot--header-border"></div>
        @if (!personPending) {
            <div
                [ngClass]="
                    layout.isMobile
                        ? 'global-search-person-snapshot--body mobile-snapshot'
                        : 'global-search-person-snapshot--body'
                "
            >
                <div class="global-search-person-snapshot--pattern-description">
                    {{ baPerson?.referencePattern?.descriptionKey | translate }}
                    <div
                        class="global-search-person-snapshot--reference-profile-link"
                    >
                        <tapestry-icon name="open_new_window"></tapestry-icon>
                        <a
                            [href]="referenceProfilesLink"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ 'jobInsights.learnLabel' | translate }}</a
                        >
                    </div>
                </div>
                <pattern-insights
                    (loading)="updateInsightsLoading($event)"
                    [baPerson]="baPerson"
                ></pattern-insights>
            </div>
        } @else {
            @if (canSendBA()) {
                <div
                    class="global-search-person-snapshot--pending-person-container"
                >
                    @if (showReferenceProfileIcon) {
                        <div class="tapestry-body body--lg bold">
                            {{
                                'candidateSnapshot.pendingAssessment.title'
                                    | translate
                            }}
                        </div>
                    } @else {
                        <div class="tapestry-body body--lg bold">
                            {{
                                'platform.employee-directory.no-assessment-peek.header'
                                    | translateFormat: [firstName]
                            }}
                        </div>
                    }
                    <div class="tapestry-body body--lg">
                        <div
                            class="global-search-person-snapshot--pending-person-body-text"
                        >
                            {{
                                'topPerformer.pending.peekPanel.body'
                                    | translateFormat: [firstName]
                            }}
                        </div>
                        @if (isAtLeastModuleAdmin && showReferenceProfileIcon) {
                            <div
                                class="global-search-person-snapshot--resend-container"
                            >
                                <div>
                                    {{
                                        'label.common-terms.date.sent'
                                            | translate
                                    }}:
                                    {{ lastSent }}
                                </div>
                                <tapestry-button
                                    class="global-search-person-snapshot--pending-person-resend-button"
                                    text="{{
                                        'jobDetails.resendAssessment'
                                            | translate
                                    }}"
                                    (buttonClicked)="resendBAAssessment()"
                                ></tapestry-button>
                            </div>
                        } @else {
                            @if (isAtLeastModuleAdmin) {
                                <div
                                    class="global-search-person-snapshot--resend-container"
                                >
                                    <tapestry-button
                                        text="{{
                                            'sendassessmenttitle' | translate
                                        }}"
                                        (buttonClicked)="
                                            sendBehavioralAssessment()
                                        "
                                    ></tapestry-button>
                                </div>
                            }
                        }
                    </div>
                </div>
            } @else {
                <div
                    class="global-search-person-snapshot--pending-person-container"
                >
                    <div class="tapestry-body body--lg bold">
                        {{
                            'person-snapshot.peek-panel-title.pending.limited-user'
                                | translateFormat: [firstName]
                        }}
                    </div>
                    <div class="tapestry-body body--lg">
                        <div
                            class="global-search-person-snapshot--pending-person-body-text"
                        >
                            {{
                                'topPerformer.pending.peekPanel.body'
                                    | translateFormat: [firstName]
                            }}
                        </div>
                        <div
                            class="global-search-person-snapshot--resend-container"
                        >
                            <tapestry-button
                                text="{{
                                    'label.common-terms.close' | translate
                                }}"
                                [color]="'tertiary'"
                                (buttonClicked)="closePeekPanel()"
                            ></tapestry-button>
                        </div>
                    </div>
                </div>
            }
        }
        @if (shouldShowInspireCTA()) {
            <global-search-inspire-cta
                [firstName]="firstName"
                [email]="email"
                [person]="baPerson"
                [personViewableInInspire]="personViewableInInspire"
                [inspireAccessStatus]="currentUserInspireAccessStatus"
            ></global-search-inspire-cta>
        }
    </div>
} @else {
    @if (!baPerson) {
        <div class="global-search-person-snapshot--load-container">
            <tapestry-spinner [altText]="" spinnerSize="lg"></tapestry-spinner>
        </div>
    }
}
